import PrimaryButton from './PrimaryButton';
import React from 'react';
import resume from '../img/resume2.jpg';
import styled from 'styled-components';

function ImageSection() {
    return (
        <ImageSectionStyle>
            <div className="left-content">
              <img src={resume} alt="" />
            </div>
            <div className="right-content">
                    <h4>I'm <span>Fahim Hasan</span></h4>
                <p className="paragraph">
                    I'm a Front-End Developer. I work with React JS, Node Js, Express JS, MongoDb, React Bootstrap, Material UI and so on. You can find some of my work on my "Projects" Page if you feel I have done a good job please write a review below... It will definitely make me more confident. 
                </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name </p>
                        <p>Nationality </p>
                        <p>Language </p>
                        <p>Location </p>
                        <p>Service </p>
                    </div>
                    <div className="info">
                        <p>  : Fahim Hasan</p>
                        <p>  : Bangladeshi </p>
                        <p>  : Bangla, English</p>
                        <p>  : Bangladesh </p>
                        <p>  : Freelancer</p>
                    </div>
                </div>
                    <a target="_blank" href="https://drive.google.com/drive/folders/1DnJQdxmOF1TI2-ne96sQsCHFOib_rKF0?usp=sharing">
                        <PrimaryButton title={'Download Cv'} />
                    </a>
            </div>
            
        </ImageSectionStyle>
    )
}

const ImageSectionStyle = styled.div`
margin-top: 5rem;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    z-index: 10;
    .left-content {
        width: 100%;
        /* height: 60vh; */
        img {
            width: 90%;
            height: 100%;
            object-fit: cover;
        }
    }

    .right-content {
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span {
                font-size: 2rem;
            }
        }
        .paragraph {
            padding: 1rem 0;
            text-align: justify;
        }
        .about-info {
            display: flex;
            padding-bottom: 1.4rem;
            .info-title {
                padding-right: 4rem;
                p{
                    font-weight: 600;
                }
            }
        }
    }

    @media only screen and (max-width: 1000px){
        flex-direction: column;
        .left-content {
            margin-bottom: 2rem;
            width: 100%;
        /* height: 60vh; */
        img {
            margin-left: 40px;
            width: 80%;
            height: 100%;
            object-fit: cover;
        }
    }
}
    @media only screen and (max-width: 600px){
        .left-content{
            width: 100%;
            img{
                margin-left: 30px;
                width: 80%;
                height: 100%;
            }
        }
        .right-content{
            p{
                font-size: .8rem;
                font-weight: 600;
                text-align: justify;
            }
            
            .about-info{
                p {
                    padding: .3rem 0;
                }
                .info-title{
                    p{
                        font-size: .6rem;
                    }
                } 
                .info {
                    p{
                        font-size: .6rem!important;
                    }
                } 
            }
        }
    }
`;

export default ImageSection
